export default __webpack_public_path__ + "static/media/Proreview-7.c555fdc3.jpg";